<template>
	<div>
		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage">
				<p class="account_manage_title">我的报告</p>

				<ul class="nav nav-tabs" role="tablist">
					<li role="presentation" class="account_manage_title_active">
						<a @click="msga=0" :class="{'account_manage_title_active':msga===0}" href="javascript:" class="myreport">我的报告</a>
					</li>
					<li role="presentation">
						<a @click="msga=1" :class="{'account_manage_title_active':msga===1}" href="javascript:">回收站</a>
					</li>
				</ul>

				<!-- Tab panes -->
				<div class="tab-content">
					<div v-show="msga===0" id="myreport" class="nano video_breviary">
						<div class="nano-content">
							<table style="width: 100%;">
								<thead>
									<tr class="row ml-0 mr-0" style="height: 40px;line-height: 40px;background: #F1F1F1;">
										<td class="col-md-2 col-2">编号</td>
										<td class="col-md-3 col-3">我生成的报告</td>
										<td class="col-md-2 col-2">IP</td>
										<td class="col-md-2 col-3">生成时间</td>
										<td class="col-md-2 col-2">操作</td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(value,key) in reportLists" class="row ml-0 mr-0">
										<td class="col-md-2 col-2">{{value.id}}</td>
										<td class="col-md-3 col-3"><a :href="value.url">{{value.nation}}</a></td>
										<td class="col-md-2 col-2">{{value.ip}}</td>
										<td class="col-md-2 col-3">{{value.time}}</td>
										<td class="col-md-2 col-2"><a href="javascripe:;" @click="delTd($event,value.id)">删除</a></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div v-show="msga===1" id="recycleBin">
						<table class="w-100">
							<thead>
								<tr class="row" style="height: 40px;line-height: 40px;background: #F1F1F1;;">
									<td class="col-md-2">编号</td>
									<td class="col-md-3">我生成的报告</td>
									<td class="col-md-2">IP</td>
									<td class="col-md-2">生成时间</td>
									<td class="col-md-2">操作</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(value,key) in recycleLists" class="row ml-0 mr-0">
									<td class="col-md-2 col-2">{{value.id}}</td>
									<td class="col-md-3 col-3"><a :href="value.url">{{value.name}}</a></td>
									<td class="col-md-2 col-2">{{value.ip}}</td>
									<td class="col-md-2 col-3">{{value.time}}</td>
									<td class="col-md-2 col-2"><a href="javascripe:;" @click="restore($event,value.id)">还原</a></td>
								</tr>
							</tbody>
						</table>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>
<script>
	export default({
		name: 'my_report',
		data: function() {
			return {
				msga:0,
				reportLists: [],
				recycleLists:[]
			}
		},
		created: function() {
			var self = this;
			this.$axios.post('/api/pc/getrecord', {memberid:53,stateid:1}).then(data => {
				var reportList=data.data.data;
				this.reportLists=reportList;
			})
			this.$axios.post('/api/pc/getrecord', {memberid:53,stateid:2}).then(data => {
				var recycleList=data.data.data;
				this.recycleLists=recycleList;
			})
		},
		
		methods: {
			delTd:function (e,num) {
				
				this.reportLists.splice(e,1)
				
				this.$axios.post('/api/pc/delreport', {memberid:53,id:num,type:1}).then(data => {
					
				})
			},
			restore:function(e,num){
				
				this.recycleLists.splice(e,1)
				
				this.$axios.post('/api/pc/delreport', {memberid:53,id:num,type:3}).then(data => {
					
				})
			}
		},
		mounted() {
			this.load();
		},
		computed:{
		 	
		}
	})
</script>
